<template>
    <transition name="fade">
    <div class="processar" style="z-index: 99999999999" v-show="exibir">
        <div>
            <strong>{{text}}...</strong><br />
            <br />
            <i class="fa fa-refresh fa-spin fa-4x"></i>
        </div>
    </div>
    </transition>
</template>

<script>
export default {

	data () {
		return {
			exibir: false,
			text: ""
		}
	},

	mounted (){
		bus.$on('load-in', (obj) => {
			this.exibir = true
			if(!_.isNil(obj.text)){
				this.text = obj.text
			}
		})

		bus.$on('load-out', () => {
			this.exibir = false
		})
	},

}
</script>

<style>

.processar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .9;
    background-color: #000;
    z-index: 9999999999999;
}

    .processar div {
        top: 36%;
        left: 50%;
        margin-left: -200px; /* A metade de sua largura. */
        position: absolute;
        width: 400px;
        color: #FFF;
        text-align: center;
        z-index: 9999999999999;
    }
</style>